import { Dialog, DialogPanel } from '@headlessui/react';
import { XMarkIcon, CalendarDaysIcon, CodeBracketIcon, CheckCircleIcon } from '@heroicons/react/24/outline';
import { useNavigate } from 'react-router-dom';

export default function ModalBienvenueNotaire({ open, onClose }) {
  const navigate = useNavigate();

  function goTo(path) {
    onClose();
    navigate(path);
  }

  return (
    <Dialog open={open} onClose={onClose} className="relative z-50">
      <div className="fixed inset-0 bg-black/60 backdrop-blur-sm" aria-hidden="true" />
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <DialogPanel className="relative bg-white rounded-2xl shadow-2xl w-full max-w-lg max-h-[90vh] overflow-y-auto">

          {/* Header */}
          <div className="bg-slate-900 px-8 pt-8 pb-8">
            <button
              onClick={onClose}
              className="absolute top-4 right-4 rounded-full bg-white/10 p-1.5 hover:bg-white/20 transition-colors"
            >
              <XMarkIcon className="h-5 w-5 text-white" />
            </button>
            <div className="inline-flex items-center gap-2 bg-indigo-600/80 rounded-full px-3 py-1 mb-4">
              <span className="text-xs font-semibold text-white">Bienvenue sur Clotere</span>
            </div>
            <h2 className="text-2xl font-bold text-white mb-1">Votre espace est prêt !</h2>
            <p className="text-slate-400 text-sm">Voici les prochaines étapes pour bien démarrer.</p>
          </div>

          {/* Body */}
          <div className="px-8 py-7 space-y-3">

            {/* Card 1 — RDV actif */}
            <div className="flex items-start gap-4 rounded-xl border border-green-100 bg-green-50 p-4">
              <div className="w-9 h-9 rounded-lg bg-green-100 flex items-center justify-center flex-shrink-0">
                <CheckCircleIcon className="h-5 w-5 text-green-600" />
              </div>
              <div>
                <p className="text-sm font-semibold text-gray-900">Prise de rendez-vous active</p>
                <p className="text-sm text-gray-500 mt-0.5">
                  Vos clients peuvent déjà prendre rendez-vous en ligne avec vous.
                </p>
              </div>
            </div>

            {/* Card 2 — Calendrier */}
            <button
              onClick={() => goTo('/app/calendrier')}
              className="w-full flex items-start gap-4 rounded-xl border border-gray-200 bg-white p-4 hover:border-indigo-300 hover:bg-indigo-50/50 transition-colors text-left group"
            >
              <div className="w-9 h-9 rounded-lg bg-indigo-100 flex items-center justify-center flex-shrink-0">
                <CalendarDaysIcon className="h-5 w-5 text-indigo-600" />
              </div>
              <div className="flex-1">
                <p className="text-sm font-semibold text-gray-900">Gérez vos disponibilités</p>
                <p className="text-sm text-gray-500 mt-0.5">
                  Synchronisez votre agenda Google / Outlook ou définissez vos plages horaires.
                  <br/> Via le menu Calendrier
                </p>
              </div>
              <span className="text-xs font-medium text-indigo-600 group-hover:translate-x-0.5 transition-transform mt-0.5 self-center">
                →
              </span>
            </button>

            {/* Card 3 — Widget */}
            <button
              onClick={() => goTo('/app/widget-rdv')}
              className="w-full flex items-start gap-4 rounded-xl border border-gray-200 bg-white p-4 hover:border-indigo-300 hover:bg-indigo-50/50 transition-colors text-left group"
            >
              <div className="w-9 h-9 rounded-lg bg-indigo-100 flex items-center justify-center flex-shrink-0">
                <CodeBracketIcon className="h-5 w-5 text-indigo-600" />
              </div>
              <div className="flex-1">
                <p className="text-sm font-semibold text-gray-900">Installez le widget sur votre site</p>
                <p className="text-sm text-gray-500 mt-0.5">
                  Intégrez la prise de RDV directement depuis votre site web en 2 minutes.
                  <br/> Via le menu Widget RDV
                </p>
              </div>
              <span className="text-xs font-medium text-indigo-600 group-hover:translate-x-0.5 transition-transform mt-0.5 self-center">
                →
              </span>
            </button>

            <button
              onClick={onClose}
              className="w-full mt-2 rounded-xl bg-indigo-600 px-6 py-3.5 text-base font-semibold text-white text-center hover:bg-indigo-500 transition-colors"
            >
              Commencer →
            </button>
          </div>

        </DialogPanel>
      </div>
    </Dialog>
  );
}
